import _request from '@/utils/request';

// 文件上传
export async function uploadFile(data) {
  const url = `/img/upload`;
  return await _request({
    method: 'POST',
    url,
    data,
    type: 'upload'
  });
}

export async function uploadDollImage(data) {
  const url = `/doll/img/upload`;
  return await _request({
    method: 'POST',
    url,
    data,
    type: 'upload'
  });
}